import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "#1f1f1f",
  viewBox: "0 -960 960 960"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M480-240q66 0 113-47t47-113v-40q0-17-11.5-28.5T600-480H360q-17 0-28.5 11.5T320-440v40q0 66 47 113t113 47m0-60q-42 0-71-29t-29-71v-20h200v20q0 42-29 71t-71 29M340-680q-34 0-60 22t-40 54q-5 11 1.5 21t18.5 13q11 3 22-2.5t16-16.5q7-13 17.5-22t24.5-9 24.5 9.5T382-588q5 11 16 16t22 2q12-3 18.5-13t1.5-21q-14-32-40-54t-60-22m280 0q-34 0-60 22t-40 54q-5 11 1.5 21t18.5 13q11 3 22-2.5t16-16.5q7-13 17.5-22t24.5-9 24.5 9.5T662-588q5 11 16 16t22 2q12-3 18.5-13t1.5-21q-14-32-40-54t-60-22M480-80q-83 0-156-31.5T197-197t-85.5-127T80-480t31.5-156T197-763t127-85.5T480-880t156 31.5T763-763t85.5 127T880-480t-31.5 156T763-197t-127 85.5T480-80m0-80q134 0 227-93t93-227-93-227-227-93-227 93-93 227 93 227 227 93" }, null, -1)
  ]))]))
}
export default { render: render }